import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-companies.container',
  templateUrl: './companies.container.component.html',
  styleUrls: ['./companies.container.component.scss']
})
export class CompaniesContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
